import { createApiConstants } from '@saucelabs/sl-util-redux';

const NAMESPACE = 'invitations';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const GET_INVITATION = createApiNamespacedConstants('GET_INVITATION');
export const ACCEPT_INVITATION = createApiNamespacedConstants('ACCEPT_INVITATION');
export const MOVE_INVITATION = createApiNamespacedConstants('MOVE_INVITATION');
export const DECLINE_INVITATION = createApiNamespacedConstants('DECLINE_INVITATION');
